import { css } from "@emotion/react";
import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Button } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";

import YouTubeAlignment from "~/components/me/bento/content/account-small/YouTubeAlignment";
import { logoutWithFirebaseAuth } from "~/lib/client/auth";
import { flexRow } from "~/lib/client/design";
import { MeShortAccountContentQuery } from "~/lib/graphql/client";

const DialogContentBody = ({
  me,
}: {
  me: MeShortAccountContentQuery["me"];
}) => {
  const router = useRouter();
  const logout = useCallback(async () => {
    await logoutWithFirebaseAuth();
    await router.push("/");
  }, [router]);
  const avatarSize = { width: 60, height: 60 };
  const iconAvatarSize = { width: 52, height: 52 };

  return (
    <div css={dialogContentBodyStyle}>
      <div css={avatarAndNameStyle}>
        {me.avatarImageUrl ? (
          <Avatar src={me.avatarImageUrl} sx={avatarSize} />
        ) : (
          <Avatar sx={avatarSize}>
            <PersonIcon sx={iconAvatarSize} />
          </Avatar>
        )}
        <h2>{me.name}</h2>
      </div>

      <Bio bio={me.bio} />
      <div css={spacerStyle} />
      <YouTubeAlignment />
      <div css={buttonContainerStyle}>
        <Button variant="outlined" onClick={logout}>
          ログアウト
        </Button>
        <Button variant="outlined">
          <Link href={"/account/edit"}>プロフィールの更新</Link>
        </Button>
      </div>
    </div>
  );
};

const spacerStyle = css`
  margin-top: 5rem;
`;

const Bio = ({ bio }: { bio: string | null | undefined }) => {
  if (bio?.toString().length == 0)
    return (
      <p css={leadWriteYourProfileRootStyle}>
        <Link href={"/account/edit"} css={linkStyle}>
          こちら
        </Link>
        から自己紹介を書くことができます。
      </p>
    );

  return <p>{bio}</p>;
};

const leadWriteYourProfileRootStyle = css`
  color: #666;
`;

const linkStyle = css`
  text-decoration: underline;
`;

const dialogContentBodyStyle = css`
  padding: 1rem;
`;

const avatarAndNameStyle = css`
  ${flexRow};
  align-items: start;
  gap: 1rem;

  h2 {
    font-size: 1.2rem;
    padding: 0;
    margin: 0.5rem 0 0;
  }
`;

const buttonContainerStyle = css`
  margin-top: 10rem;
  ${flexRow};
  justify-content: flex-end;
  gap: 0.25rem;
`;

export default DialogContentBody;
